import React, {useState} from 'react';
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DatePickerComponentProps {
  value: any;
    setDate: any;
    issueYear?: any;
}


export default function DatePickerComponent ({
    value,
    setDate,
    issueYear
} : DatePickerComponentProps) {
    const [startDate, setStartDate] = useState(new Date());
    const issueYears = range(1990, getYear(new Date()) + 1, 1);
    const years = range(1990, getYear(new Date()) + 20, 1);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return (
      <DatePicker
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              {"<"}
            </button>
            <select
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {issueYear ? (
<>
{issueYears.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
</>
              ) : (
                <>
                {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
                </>
              )}
             
              
            </select>
  
            <select
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
  
            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              {">"}
            </button>
          </div>
        )}
        selected={value}
        onChange={(date) => setDate(date)}
        customInput={<ExampleCustomInput />}
        placeholder={"dd/mm/yyyy"}
        value={value}
      />
    );
  };

// @ts-ignore
  const ExampleCustomInput = React.forwardRef(({ value, onClick, ref }) => (
    <div>
      <input
        type="text"
        className="form-control border-dark bg-white"
        onClick={onClick}
        ref={ref}
        value={value}
      />
    </div>
  ));